import { Authenticator } from '@aws-amplify/ui-react';
import { Amplify, Auth } from 'aws-amplify';
import React, { useEffect, useState } from 'react';
import { envConfig } from '../../configuration/aws-exports';
import Spinner from '@cloudscape-design/components/spinner';

interface AuthProviderProps {
  children: JSX.Element;
}

export const AuthProvider = ({ children }: AuthProviderProps): JSX.Element => {
  const [isConfiguring, setIsConfiguring] = useState(true);

  useEffect(() => {
    const configure = async () => {
      try {
        Amplify.configure(envConfig);
        await Auth.currentAuthenticatedUser();
        setIsConfiguring(false);
      } catch (error) {
        console.error(error);
        Auth.federatedSignIn({
          customProvider: 'AmazonFederate',
        });
      }
    };
    configure();
  }, []);

  if (isConfiguring) {
    return <Spinner />;
  }

  return (
    <React.Suspense fallback={<Spinner />}>
      <Authenticator.Provider>{children}</Authenticator.Provider>
    </React.Suspense>
  );
};
